<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                    <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name" dataKey="id"
                              filter :placeholder="$t('AppOrganizationSettings.Organização')" class="dropdown-250">
                    </Dropdown>
                </div>
            </div>
            <div class="kt-portlet__body no-padding">
                <div v-show="selectedOrg" class="organization-settings">
                    <AppAgroSettingsCard ref="agroSettings" :agro-preferences="agroPreferences"
                                         :getting-data="loading" @save="saveAgroPreferences"/>
                </div>
                <div v-if="!selectedOrg"  class="d-flex justify-content-center mt-5">
                    <div class="text-center flex-column kt-font-lg">
                        <div class="font-weight-bold kt-font-xl">
                            {{ $t('AppOrganizationSettings.Selecione uma organização para editá-la') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Dropdown from 'primevue/dropdown'
import AppAgroSettingsCard from "./AppAgroSettingsCard.vue";

import OrganizationsService from "@/services/OrganizationsService";

export default {
    mounted() {
        this.organizationsService = new OrganizationsService();
        this.getOrganizations();
    },
    data() {
        return {
            organizationsService: null,
            loading: false,
            organizations: [],
            selectedOrg: null,
            storedChosenOptions: null,
            agroPreferences: null
        }
    },
    methods: {
        getOrganizations() {
            this.organizationsService.getAllV3()
                .then((response) => {
                    this.organizations = response.sort((a, b) => a.name.localeCompare(b.name));
                    this.selectSavedOrg();
                    this.getOrganizationAgroPreferences();
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOrganizationSettings.Não foi possivel buscar as organizações'),
                        life: 5000
                    });
                })
        },
        selectSavedOrg() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.organizations.filter(a => this.storedChosenOptions['clients'].some(b => a.id === b.id))[0];
        },
        getOrganizationAgroPreferences() {
            if (!this.selectedOrg) {
                this.loading = false;
                return;
            }

            this.organizationsService.getOrganizationAgroPreferences(this.selectedOrg.id)
                .then((response) => {
                    this.agroPreferences = response.status === 204 ? null : response.data;
                })
                .catch(() => {
                    this.goBack();
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOrganizationSettings.Houve um erro ao buscar as preferências agronômicas da organização'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        saveAgroPreferences(preferences) {
            if (!this.agroPreferences) {
                this.createAgroPreferences(preferences);
                return
            }

            this.updateAgroPreferences(preferences);
        },
        createAgroPreferences(preferences) {
            this.organizationsService.createOrganizationAgroPreferences(this.selectedOrg.id, preferences)
                .then(() => {
                    this.goBack();
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppOrganizationSettings.Preferências agronômicas da organização criada com sucesso'),
                        life: 5000
                    });
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOrganizationSettings.Houve um erro ao criar as preferências agronômicas da organização'),
                        life: 5000
                    });
                })
        },
        updateAgroPreferences(preferences) {
            this.organizationsService.updateOrganizationAgroPreferences(this.agroPreferences.id, preferences)
                .then(() => {
                    this.goBack();
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppOrganizationSettings.Preferências agronômicas da organização atualizadas com sucesso'),
                        life: 5000
                    });
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOrganizationSettings.Houve um erro ao atualizar as preferências agronômicas da organização'),
                        life: 5000
                    });
                })
        },
        goBack() {
            this.$router.go(-1);
        }
    },
    watch: {
        selectedOrg: function (val) {
            if (val) {
                this.$refs.agroSettings.restoreData();
                this.getOrganizationAgroPreferences();
                this.saveChosenOptionsToLocalStorage();
            }
        },
    },
    components: {
        Dropdown, AppAgroSettingsCard
    }
}
</script>

<style scoped>
.dropdown-250 {
    width: 250px;
}
</style>
